import BaseApi from './BaseApi';

class PharmacyMenuApi extends BaseApi {
  protected getSpecificApiPrefix(): string {
    return 'managers/pharmacy/menus';
  }
}

export default PharmacyMenuApi;
